import { createFileRoute, notFound } from '@tanstack/react-router';
import { lazyScreen } from '@/shared/screen/lazy-screen';

// /dev/central-regras (só dev): as telas reais sobre o backend em memória.
export const Route = createFileRoute('/dev/central-regras/')({
  beforeLoad: () => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- notFound é o contrato do Router.
    if (!import.meta.env.DEV) throw notFound();
  },
  component: import.meta.env.DEV ? lazyScreen(() => import('./-page'), 'ProductRulesDevPage') : () => null,
});
